<app-navbar></app-navbar>

<div class="container" style="top:3px; position: relative; padding: 0px !important">
    <router-outlet></router-outlet>
</div>

<app-footer [ngClass]="{
    'appfooter': formsInit,
    'appfooterunset': !formsInit}"></app-footer>